import React, { Component } from "react";
import withRouter from "../withRouter/withRouter";

import "./Categories.css";

import no_image_img from "../../no-image.png";
import ListScroll from "../ListScroll/ListScroll";

class Categories extends Component {
    constructor(props) {
        super(props);
        this.no_image = { url: no_image_img };
    }
    state = {};
    render() {
        let { categories, router } = this.props;

        return (
            <div className='categories container'>
                <div className='caption'>دسته بندی ها</div>
                <div className='wraper'>
                    <ListScroll
                        items={categories}
                        Component={(c, key) => {
                            c = c.item;
                            return (
                                <div
                                    className='item'
                                    key={key}
                                    onClick={(ev) => {
                                        router.navigate(
                                            `/search?categories=[\"${c.name}\"]`
                                        );
                                    }}
                                >
                                    <img src={c.image} />
                                    <div className='name'>{c.name}</div>
                                </div>
                            );
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default withRouter(Categories);
